import { FileField, SubmitHandler } from '@ff-it/form';
import type { RenderProps } from '@ff-it/ui';
import { DialogForm } from 'components';
import { ReactElement } from 'react';
import { required } from 'utilities';

export function ImportPlanDialog(
  props: RenderProps<undefined> & {
    submitHandler: SubmitHandler<{ file: File }>;
  },
): ReactElement {
  return (
    <DialogForm {...props} title="Import plan">
      <FileField name="file" label="File" required validate={required} />
    </DialogForm>
  );
}
